import { decodeSuiPrivateKey } from '@mysten/sui/cryptography';
import { Ed25519Keypair } from '@mysten/sui/keypairs/ed25519';
import { fromB64 } from '@mysten/bcs';
import {
  SUI_TYPE_ARG,
  SUI_FRAMEWORK_ADDRESS,
  normalizeSuiAddress,
} from '@mysten/sui/utils';
const SUI_ADDR_N = normalizeSuiAddress('0x2');
function isValidCoinType(s?: string): boolean {
  if (!s) return false;
  const COIN_TYPE_REGEX =
    /^0x[0-9a-fA-F]{1,64}::[A-Za-z_][A-Za-z0-9_]*::[A-Za-z_][A-Za-z0-9_]*$/;
  return COIN_TYPE_REGEX.test(s.trim());
}

function isSuiCoinType(coinType: string): boolean {
  if (!coinType) return false;

  const parts = coinType.trim().split('::');
  if (parts.length !== 3) return false;

  const [addr, moduleName, structName] = parts.map(s => s.trim());

  try {
    return (
      normalizeSuiAddress(addr) === SUI_ADDR_N &&
      moduleName.toLowerCase() === 'sui' &&
      structName.toUpperCase() === 'SUI'
    );
  } catch {
    return false;
  }
}

function loadKeypairFromSuiPrivkey(privkey: string): Ed25519Keypair {
  const { schema, secretKey } = decodeSuiPrivateKey(privkey.trim());

  // schema 在新版本里等价于 scheme，这里只是多一道保护
  if (schema !== 'ED25519') {
    throw new Error(`暂时只支持 ED25519 私钥，当前为: ${schema}`);
  }

  // ✅ secretKey 已经是 Uint8Array，不需要 fromB64
  return Ed25519Keypair.fromSecretKey(secretKey);
}
function walletFromSuiPrivkey(privkey: string) {
  const keypair = loadKeypairFromSuiPrivkey(privkey);
  const address = keypair.getPublicKey().toSuiAddress();

  return {
    keypair,
    address,
    privatekey: privkey
  };
}

export { isValidCoinType, walletFromSuiPrivkey, isSuiCoinType }